import styled from 'styled-components';

export const ProductInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
`;
